import * as React from "react";
import { AppointmentCustomerFormContainer } from "../../../../../../../../../components/AppointmentCustomerForm/v3/components/AppointmentCustomerForm/AppointmentCustomerFormContainer.js";
import { getBookAppointmentStore } from "../../../../../../../data/v3/pages/BookAppointment/data/book-appointment-store-by-id.js";
import { getBookAppointmentType } from "../../../../../../../data/v3/pages/BookAppointment/data/book-appointment-type.js";
import { MissingStoreIdError, AlternativeUrlStoreError, MissingTypeIdError, MissingTimeSlotStartError, MissingTimeSlotEndError, InvalidVirtualAppointmentError, StoreNotFoundError, TypeNotFoundError, TypeNotAvailableForStoreError, LinkedAppointmentTypeNotValidError } from "../../../../../../../v3/pages/BookAppointment/errors.js";
import useBookAppointmentStoreWithUrlParam from "../../../../../../../hooks/v3/pages/BookAppointment/hooks/use-book-appointment-store-with-url-param.js";
import useBookAppointmentTimeSlotWithUrlParam from "../../../../../../../hooks/v3/pages/BookAppointment/hooks/use-book-appointment-time-slot-with-url-param.js";
import useBookAppointmentTypeWithUrlParam from "../../../../../../../hooks/v3/pages/BookAppointment/hooks/use-book-appointment-type-with-url-param.js";
import { getFormattedParams, hasValidVirtualAppointmentParams, generateVirtualAppointmentStoreByIdData, hasInvalidVirtualAppointmentParams, isAppointmentTypeValid } from "../../../../../../../v3/pages/BookAppointment/utils.js";
const WhoRoot = () => {
  useBookAppointmentStoreWithUrlParam();
  useBookAppointmentTypeWithUrlParam();
  useBookAppointmentTimeSlotWithUrlParam();
  return /* @__PURE__ */ React.createElement(AppointmentCustomerFormContainer, null);
};
WhoRoot.getServerSideProps = async (apolloClient, params, locale) => {
  const formattedParams = getFormattedParams(params);
  if (formattedParams.globalStoreId === void 0) {
    throw MissingStoreIdError();
  }
  if (formattedParams.alternativeUrlStores?.includes(formattedParams.globalStoreId)) {
    throw AlternativeUrlStoreError();
  }
  if (formattedParams.typeId === void 0) {
    throw MissingTypeIdError();
  }
  if (formattedParams.start === void 0) {
    throw MissingTimeSlotStartError();
  }
  if (formattedParams.end === void 0) {
    throw MissingTimeSlotEndError();
  }
  let promises = [null, null];
  if (hasValidVirtualAppointmentParams(formattedParams)) {
    const type2 = await getBookAppointmentType(apolloClient, formattedParams.typeId, locale);
    promises = [
      type2 ? generateVirtualAppointmentStoreByIdData(formattedParams.virtualStoreCode, type2) : null,
      // TODO: MACC-19077 formattedParams.virtualStoreCode is always a string. Remove as string before merging to master.
      type2
    ];
  } else if (hasInvalidVirtualAppointmentParams(formattedParams)) {
    throw InvalidVirtualAppointmentError();
  } else {
    promises = [
      getBookAppointmentStore(
        apolloClient,
        formattedParams.globalStoreId,
        locale,
        formattedParams.tryInStoreFlow,
        formattedParams.groupId
      ),
      getBookAppointmentType(apolloClient, formattedParams.typeId, locale)
    ];
  }
  const [store, type] = await Promise.all(promises);
  if (!store) {
    throw StoreNotFoundError();
  } else if (!type) {
    throw TypeNotFoundError();
  } else if (type && !isAppointmentTypeValid({
    typeId: type?.id,
    store
  })) {
    throw TypeNotAvailableForStoreError();
  } else if (formattedParams?.linkedAppointmentTypeId && !isAppointmentTypeValid({ typeId: formattedParams.linkedAppointmentTypeId, store })) {
    throw LinkedAppointmentTypeNotValidError();
  }
  return Promise.resolve({
    store,
    type,
    timeSlot: { from: formattedParams.start, until: formattedParams.end }
  });
};
export {
  WhoRoot as default
};
//# sourceMappingURL=WhoRoot.js.map
